import { __makeTemplateObject } from "tslib";
/*
 * @Author: Nello Huang (nello.huang@ringcentral.com)
 * @Date: 2019-07-22 15:32:51
 * Copyright © RingCentral. All rights reserved.
 */
import FormControl from '@material-ui/core/FormControl';
import { styled } from '../../foundation';
/** @release */
var RcFormControl = styled(FormControl)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
RcFormControl.displayName = 'RcFormControl';
export { RcFormControl };
var templateObject_1;
